import React, { useEffect, useState } from "react";
import UserLayout from "../Componets/UserLayout";
import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import dayjs from "dayjs"; // Import dayjs for date formatting
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";

import { GrCompliance } from "react-icons/gr";
import { MdOutlinePendingActions } from "react-icons/md";
import { BsClipboardData } from "react-icons/bs";
import { FaClipboardQuestion } from "react-icons/fa6";
import { AiOutlineStop } from "react-icons/ai";
import { RiAdminLine } from "react-icons/ri";

export default function AllocateSheets() {
  const navigate = useNavigate();
  const [data, setData] = useState([]); // State to hold the API response data
  const [searchText, setSearchText] = useState(""); // State to hold the search text
  const [modalData, setModalData] = useState(null); // State to hold modal response data
  const apiUrl = process.env.REACT_APP_API_URL; // Retrieve the API URL from environment variables
  const location = useLocation();
  const { id, subjectId, examname } = location.state || {}; // Extract the exam ID and subject ID from location state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [processingButtons, setProcessingButtons] = useState({}); // Track loading state per button

  // Checking if user is logged in, if not then redirect to login page
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== "USER") {
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);

  // Fetch data from API
  useEffect(() => {
    const token = localStorage.getItem("token");
    async function fetchDataWithAxios() {
      try {
        const response = await axios.get(
          `${apiUrl}/api/answersheet/barcode/detail/${id}/${subjectId}?allocationType=NORMAL`,
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        );
        console.log("Fetched data:", response.data); // Log the response data to check the structure
        setData(response.data); // Update the state with the fetched data
      } catch (error) {
        console.error("Error fetching the data", error); // Log any errors
        if (error.response?.status === 401) {
          navigate("/");
        }
        toast.error(error.response?.data?.message || "Failed to fetch data"); // Check if the error message exists
      }
    }

    if (id && subjectId) {
      fetchDataWithAxios(); // Call the function when the component mounts
    }
    // eslint-disable-next-line
  }, [apiUrl, id, subjectId]);
            
const handleViewAnswerSheet = async (row) => {
  if (processingButtons[row.barcode]) return;

  // ✅ Mark button as processing
  setProcessingButtons(prev => ({ ...prev, [row.barcode]: true }));

  try {
    // ✅ Fast track if already completed
    if (row.status === "COMPLETED") {
      navigate("/ViewAnswerSheet", {
        state: {
          id,
          subjectId,
          barcode: row.barcode,
          barcodeId: row.barcodeId,
          allocationType: "NORMAL",
          StaTus: row.status,
        },
      });
      return; // ✅ Skip further checks
    }

    // ✅ Continue normal permission flow
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${apiUrl}/api/faculty/list/${id}/${subjectId}/${row.barcodeId}`,
      {
        headers: { Authorization: `${token}` },
      }
    );

    const facultyInfo = response.data.facultyLocationList;
    const webcamRequired = facultyInfo.webcam === true;
    const locationRequired = facultyInfo.location === true;

    if (!webcamRequired && !locationRequired) {
      navigate("/ViewAnswerSheet", {
        state: {
          id,
          subjectId,
          barcode: row.barcode,
          barcodeId: row.barcodeId,
          allocationType: "NORMAL",
          StaTus: row.status,
        },
      });
      return;
    }

    if (webcamRequired) {
      const hasWebcam = window.confirm(
        "This evaluation requires a webcam for monitoring.\n\nClick OK if you have a camera, or Cancel if you don't."
      );
      if (!hasWebcam) return;

      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasVideoInput = devices.some(device => device.kind === 'videoinput');
      if (!hasVideoInput) {
        alert("No camera found on this device.");
        return;
      }

      try {
        const cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
        cameraStream.getTracks().forEach(track => track.stop());
      } catch (err) {
        alert(
          err.name === "NotAllowedError"
            ? "Camera permission is blocked. Please enable it in your browser settings to continue."
            : "Unable to access the camera. Error: " + err.message
        );
        console.error("Camera access error:", err);
        return;
      }
    }

    if (locationRequired) {
      const getLocation = () =>
        new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 10000,
          });
        });

      try {
        await getLocation();
      } catch (err) {
        alert("Location permission denied or unavailable. Please enable location access to proceed.");
        console.error("Location access error:", err);
        return;
      }
    }

    navigate("/ViewAnswerSheet", {
      state: {
        id,
        subjectId,
        barcode: row.barcode,
        barcodeId: row.barcodeId,
        allocationType: "NORMAL",
        StaTus: row.status,
      },
    });

  } catch (error) {
    console.error("Failed to fetch permission settings:", error);
    toast.error("Failed to fetch webcam/location settings", { autoClose: 5000 });
  } finally {
    setProcessingButtons(prev => ({ ...prev, [row.barcode]: false }));
  }
};




  const formatDate = (dateString) => {
    if (!dateString) {
      return "--"; // Return a default value or placeholder when dateString is null or undefined
    }
    return dayjs(dateString).format("DD/MM/YYYY");
  };

  // Filter data based on search text
  const filteredData = data.filter(
    (item) =>
      item.barcode &&
      item.barcode.toLowerCase().includes(searchText.toLowerCase())
  );

  // Fetch image index data and set it to modal
  const handleModalOpen = async (barcode) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${apiUrl}/api/answersheet/imageIndex/${id}/${subjectId}/${barcode}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      console.log(response.data); // Log the response data to check the structure
      setModalData(response.data); // Set the response data to state to display in modal
    } catch (error) {
      console.error("Error fetching image index data", error);
      if (error.response?.status === 401) {
        navigate("/");
      }
      toast.error("Failed to fetch data for modal");
    }
  };

  // Define columns
  const columns = [
    {
      name: "No",
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: "50px",
      center: "true",
    },
    {
      name: "Status",
      width: "70px",
      center: "true",
      cell: (row) => (
        <div className="pt-0" id="table-btn">
          {row.isRejectedAnsweeSheet ? (
            <span className="badge text-bg-danger p-2">
              <AiOutlineStop />
            </span>
          ) : (
            <>
              {/* Check for Copy Case */}
              {row.isCopaycase && (
                <span className="badge text-bg-danger fs-4">
                  <FaClipboardQuestion />
                </span>
              )}

              {/* Manual Mark Badge */}
              {row.isManualMark && (
                <span className="badge text-danger fs-4">
                  <RiAdminLine />
                </span>
              )}

              {/* Other status badges */}
              {!row.isCopaycase &&
                !row.isManualMark &&
                row.status === "COMPLETED" && (
                  <span className="badge text-success fs-4">
                    <GrCompliance />
                  </span>
                )}
              {!row.isCopaycase &&
                !row.isManualMark &&
                row.status === "INPROGRESS" && (
                  <span className="badge text-warning fs-4">
                    <BsClipboardData />
                  </span>
                )}
              {!row.isCopaycase &&
                !row.isManualMark &&
                row.status === "PENDING" && (
                  <span className="badge text-secondary fs-4">
                    <MdOutlinePendingActions />
                  </span>
                )}
            </>
          )}
        </div>
      ),
    },
    {
      name: "Barcode",
      selector: (row) => row.barcode,
      sortable: true,
    },
    {
      name: "Start Date",
      selector: (row) => formatDate(row.startDate),
      width: "100px",
    },
    {
      name: "End Date",
      selector: (row) => formatDate(row.endDate),
      width: "90px",
    },
    {
      name: "Time",
      selector: (row) => row.totalTime,
    },
    {
      name: "Marks",
      selector: (row) => `${row.obtainedMarks}/${row.totalMarks}`,
      width: "80px",
    },
    {
      name: "Details",
      width: "115px",
      center: "true",
      cell: (row) => (
        <div>
          <button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Evaluation Answersheet"
            className={`btn btn-secondary btn-sm mx-2 ${processingButtons[row.barcode] ? "opacity-50" : ""
              }`}
            onClick={() => handleViewAnswerSheet(row)}
            disabled={
              row.isRejectedAnsweeSheet ||
              row.isCopaycase ||
              row.isManualMark ||
              processingButtons[row.barcode] // Check loading state for this specific button
            }
          >
            {processingButtons[row.barcode] ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <i className="bi bi-list-columns"></i>
            )}
          </button>
          <button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Show Answersheet"
            className="btn btn-primary btn-sm"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
            onClick={() => handleModalOpen(row.barcode)}
          >
            <i className="bi bi-clipboard"></i>
          </button>
        </div>
      ),
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.isCopaycase,
      style: {
        color: "red",
      },
    },
  ];

  return (
    <UserLayout ac2="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                <Link to="/UserHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/AnswerSheet">Exams</Link>
              </li>
              <li className="breadcrumb-item active">
                Allocate Sheets of ({examname})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <div className="datatable-top">
          <div className="datatable-search">
            <input
              className="form-control"
              type="search"
              name="search"
              placeholder="Search"
              title="Search within table"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)} // Update search text on change
            />
          </div>
        </div>
        <DataTable
          columns={columns}
          data={filteredData} // Use filtered data for the table
          pagination
          className="custom-table"
          conditionalRowStyles={conditionalRowStyles}
          paginationPerPage={rowsPerPage} // Set rows per page
          paginationTotalRows={filteredData.length} // Total number of records
          paginationDefaultPage={currentPage} // Default starting page
          onChangePage={(page) => setCurrentPage(page)} // Update current page
          onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)} // Update rows per page
        />
        <ToastContainer
          position="top-center"
          style={{ width: "auto" }}
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </main>

      {/* Answer Sheet Modal */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-l modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                Answersheet{" "}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {modalData ? (
                <div>
                  <div className="image-gallery">
                    {modalData.images &&
                      modalData.images.map((image, index) => (
                        <div
                          key={index}
                          className="image-container border border-dark mb-2"
                        >
                          <img
                            src={`${image.base64Image}`}
                            alt={image.imageName}
                            style={{ maxWidth: "100%", height: "auto" }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                <p>Loading...</p> // Show loading while fetching data
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <Tooltip id="my-tooltip" />
    </UserLayout>
  );
}